var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42857 0C0.639593 0 0 0.639593 0 1.42857V10C0 10.789 0.639593 11.4286 1.42857 11.4286H7.14286C7.93184 11.4286 8.57143 10.789 8.57143 10V1.42857C8.57143 0.639593 7.93184 0 7.14286 0H1.42857ZM11.4286 1.42857C11.4286 0.639593 12.0682 0 12.8571 0H18.5714C19.3604 0 20 0.639593 20 1.42857V4.3C20 5.08897 19.3604 5.72857 18.5714 5.72857H12.8571C12.0682 5.72857 11.4286 5.08897 11.4286 4.3V1.42857ZM11.4286 10C11.4286 9.21103 12.0682 8.57143 12.8571 8.57143H18.5714C19.3604 8.57143 20 9.21103 20 10V18.5714C20 19.3604 19.3604 20 18.5714 20H12.8571C12.0682 20 11.4286 19.3604 11.4286 18.5714V10ZM0 15.7C0 14.911 0.639593 14.2714 1.42857 14.2714H7.14286C7.93184 14.2714 8.57143 14.911 8.57143 15.7V18.5714C8.57143 19.3604 7.93184 20 7.14286 20H1.42857C0.639593 20 0 19.3604 0 18.5714V15.7Z",
    fill: "#CBCED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardicon);
export default __webpack_public_path__ + "static/media/dashboardicon.deb860df628b4de2d2d3cfe854246e9e.svg";
export { ForwardRef as ReactComponent };